<div class="content">
    <div class="modal-header">
        <span> {{ data.protocolName }} </span>
        <button class="close-icon" (click)="closeModal()">
            <img src="../../../assets/images/cabruca/close-icon.svg" alt="close-icon">
        </button>
    </div>

    <div class="advantages">
        <p class="title"> Critérios: </p>
        <ul>
            @for(li of reasons; track $index){
            <li> {{li}} </li>
            }
        </ul>
    </div>
</div>